import { useEffect } from 'react';

const SEOMetaTags = ({ loja, brand }) => {
  useEffect(() => {
    if (!loja) return;

    const url = `https://${brand}.grub.digital`;
    const logoUrl = loja.logo_url ? `https://grubupload.s3.amazonaws.com/${loja.logo_url}` : 'https://grub.digital/logo.png';
    
    // Usar sempre a primeira imagem da galeria (imagem principal do restaurante)
    let imageUrl = logoUrl;
    if (loja.galeria && Array.isArray(loja.galeria) && loja.galeria.length > 0) {
      imageUrl = `https://grubupload.s3.amazonaws.com/${loja.galeria[0].url}`;
    }
    
    const description = `Faça seu pedido online no ${loja.nome}. ${loja.tipo || 'Restaurante'} localizado em ${loja.endereco?.cidade || ''}. Delivery, balcão e mesa. Pagamento via PIX e cartão.`;
    const title = `${loja.nome} - Cardápio Digital | Peça Online | GRUB`;

    // Update document title
    document.title = title;

    // Helper function to update or create meta tag
    const updateMetaTag = (selector, attribute, content) => {
      let element = document.querySelector(selector);
      if (!element) {
        element = document.createElement('meta');
        if (selector.includes('property')) {
          element.setAttribute('property', selector.replace('meta[property="', '').replace('"]', ''));
        } else {
          element.setAttribute('name', selector.replace('meta[name="', '').replace('"]', ''));
        }
        document.head.appendChild(element);
      }
      element.setAttribute(attribute, content);
    };

    // SEO Meta Tags
    updateMetaTag('meta[name="description"]', 'content', description);
    updateMetaTag('meta[name="keywords"]', 'content', `${loja.nome}, ${loja.tipo || 'restaurante'}, delivery, pedido online, ${loja.endereco?.cidade || ''}, cardápio digital`);
    
    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);

    // Open Graph
    updateMetaTag('meta[property="og:url"]', 'content', url);
    updateMetaTag('meta[property="og:title"]', 'content', title);
    updateMetaTag('meta[property="og:description"]', 'content', description);
    updateMetaTag('meta[property="og:image"]', 'content', imageUrl);
    updateMetaTag('meta[property="og:site_name"]', 'content', loja.nome);

    // Twitter Card
    updateMetaTag('meta[name="twitter:url"]', 'content', url);
    updateMetaTag('meta[name="twitter:title"]', 'content', title);
    updateMetaTag('meta[name="twitter:description"]', 'content', description);
    updateMetaTag('meta[name="twitter:image"]', 'content', imageUrl);

    // Structured Data (JSON-LD)
    let scriptTag = document.querySelector('script[type="application/ld+json"]');
    if (!scriptTag) {
      scriptTag = document.createElement('script');
      scriptTag.setAttribute('type', 'application/ld+json');
      document.head.appendChild(scriptTag);
    }

    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Restaurant",
      "name": loja.nome,
      "description": description,
      "url": url,
      "logo": logoUrl,
      "image": imageUrl,
      "servesCuisine": loja.tipo || "Brasileira",
      "priceRange": "$$",
      "acceptsReservations": "False",
      "hasMenu": `${url}/`,
      "paymentAccepted": "PIX, Cartão de Crédito, Cartão de Débito"
    };

    // Add address if available
    if (loja.endereco) {
      structuredData.address = {
        "@type": "PostalAddress",
        "streetAddress": `${loja.endereco.logradouro}, ${loja.endereco.numero}`,
        "addressLocality": loja.endereco.cidade,
        "addressRegion": loja.endereco.estado,
        "postalCode": loja.endereco.cep,
        "addressCountry": "BR"
      };
    }

    // Add telephone if available
    if (loja.whatsapp) {
      structuredData.telephone = `+55${loja.whatsapp}`;
    }

    // Add opening hours if available
    if (loja.horarios && loja.horarios.length > 0) {
      const diasMap = { 1: 'Sunday', 2: 'Monday', 4: 'Tuesday', 8: 'Wednesday', 16: 'Thursday', 32: 'Friday', 64: 'Saturday' };
      structuredData.openingHoursSpecification = loja.horarios
        .filter(h => h.ativo === true || h.ativo === 1)
        .map(h => ({
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": diasMap[h.dia],
          "opens": h.horario_inicial.substring(0, 5),
          "closes": h.horario_final.substring(0, 5)
        }));
    }

    scriptTag.textContent = JSON.stringify(structuredData);

  }, [loja, brand]);

  return null;
};

export default SEOMetaTags;
